/**
 * Copyright (c) 2026-present, Bruno Carvalho de Araujo.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */

import { type FC } from 'react'
import { Spinner } from 'react-bootstrap'

export type Props = {}

/**
 * Loader is described here.
 *
 * @example
 * ```jsx
 * <Loader />
 * ```
 *
 * @since 09/02/2026
 * @link https://react-styleguidist.js.org/docs/documenting.html
 */
const Loader: FC<Props> = (props) => {
  return (
    <div className='d-flex justify-content-center align-items-center' style={{ height: '100dvh' }}>
      <Spinner size='sm' animation='border' />
    </div>
  )
}

export default Loader
